module.exports = __webpack_public_path__ + "static/img/5G.3a477d0b.gif";